import { useDispatch } from 'react-redux';
import { FlexContainer, Buttons, Text } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import StorageService from 'Services/storage';
import { history } from 'Store';
import { showModalAction } from 'Store/modules/app/actions';
import useTranslation from 'Hooks/useTranslation';
import { useFlags } from 'Hooks/useFlags';
import { useGetQueryUserIsOnReintent } from 'Containers/Dashboard/hooks';
import RetrievalInfo from 'Containers/Dashboard/components/TaxScreen/components/RetrievalInfo';
import { routes } from 'Constants/routes';
import { lottiesPaths } from 'Constants/lottiesPaths';
import { TAX_SEASON_OVER_MODAL } from 'Constants/modals';
import { FlagsKey, TaxScreenType } from 'Types/common';
import * as Styled from '../styles';

const CURRENT_QUIZ_KEY = 'current_quiz';

const Initial = ({ tax }: TaxScreenType): JSX.Element => {
  const { t } = useTranslation(locizeNS.DASHBOARD);
  const reintents = useGetQueryUserIsOnReintent();
  const dispatch = useDispatch();
  const { taxYear, enabled } = tax;
  const { enabled: flowEnabled } = useFlags(FlagsKey.FLOW_ENABLED);

  const errorDG = !!StorageService.getItem('dg');
  const currentQuiz = StorageService.getItem(CURRENT_QUIZ_KEY);
  const handleOnClick = (): void => {
    if (flowEnabled) {
      dispatch(showModalAction({ options: { type: TAX_SEASON_OVER_MODAL } }));
    } else {
      history.push(currentQuiz || routes.DATAGATHERING_INFO);
    }
  };

  const isOnReintent = Boolean(reintents?.executedAttempts && reintents.executedAttempts > 1);

  return isOnReintent ? (
    <RetrievalInfo tax={tax} />
  ) : (
    <>
      <Styled.KiteLottie options={{ path: lottiesPaths.GREEN_KITE }} />
      <FlexContainer
        justify="center"
        direction="column"
        align="center"
        fullHeight
        gap="dimension_08"
      >
        <Text size="L_L_S" color="dark" type="headline">
          {taxYear}
        </Text>
        <Text type="paragraphs" size="L_L_M" color="dark" align="center">
          {t('TaxScreen.Initial.title', { context: flowEnabled && 'flowEnabled' })}
        </Text>
        <Styled.StyledLottie
          options={{
            path: lottiesPaths.DASHBOARD_DATA_RETRIEVAL,
            rendererSetting: { progressiveLoad: true },
          }}
        />
        <Styled.ButtonsWrapper gap="dimension_16">
          <Buttons.Classic
            testID="startButton"
            size="m"
            mode="primary"
            disabled={!enabled || errorDG}
            onClick={handleOnClick}
            label={t('TaxScreen.Initial.CTA', { context: flowEnabled && 'flowEnabled' })}
          />
        </Styled.ButtonsWrapper>
      </FlexContainer>
    </>
  );
};

export default Initial;
